import config from './config.json'

class Config {
    constructor() {
        this.INTERNAL = true
        this.MOCK_SERVICE = config.MOCK_SERVICE

        this.API_URL = config.API_URL
        this.API_AUTH_URL = config.API_AUTH_URL
        this.API_PAYMENT_URL = config.API_PAYMENT_URL
        this.WS_URL = config.WS_URL

        this.API_REQUEST_TIMEOUT = config.API_REQUEST_TIMEOUT
        this.API_DEALER_EVENTS_REQUEST_TIMEOUT = config.API_DEALER_EVENTS_REQUEST_TIMEOUT
        this.API_COMMANDS_REQUEST_TIMEOUT = config.API_COMMANDS_REQUEST_TIMEOUT
        this.API_ARCHIVE_REQUEST_TIMEOUT = config.API_ARCHIVE_REQUEST_TIMEOUT
        this.API_MARKETPLACE_REQUEST_TIMEOUT = config.API_MARKETPLACE_REQUEST_TIMEOUT

        this.APP_VERSION = config.APP_VERSION

        //DASHBOARD_TYPE must be 3 or 6"
        this.DASHBOARD_TYPE = config.DASHBOARD_TYPE

        this.CHANGE_ORGANIZATION = config.CHANGE_ORGANIZATION
        this.MARKET_PLACE = config.MARKET_PLACE
        this.CHANGE_DEALER = config.CHANGE_DEALER

        this.PAYMENT_ENABLED = config.PAYMENT_ENABLED

        this.STATIONS_MOBILE = config.STATIONS_MOBILE
        this.STATIONS_INTERNAL = config.STATIONS_INTERNAL
        this.STATIONS_SIMULATORS = config.STATIONS_SIMULATORS

        this.USERS_FULLINFO = config.USERS_FULLINFO
        this.USERS_MAILING = config.USERS_MAILING
        this.USERS_PHONE_ACTIVATION_ENABLED = config.USERS_PHONE_ACTIVATION_ENABLED
        this.USERS_ACTIVATION_SHOW = config.USERS_ACTIVATION_SHOW
        this.USERS_SPLIT_ROLES = config.USERS_SPLIT_ROLES

        this.EXCEL_EXPORT_LIMIT = config.EXCEL_EXPORT_LIMIT

        this.PHONE_VALIDATION_REGEX = config.PHONE_VALIDATION_REGEX

        this.PATH_GRAPH = config.PATH_GRAPH
        this.PATH_SETTINGS = config.PATH_SETTINGS
        this.PATH_LOGIN = config.PATH_LOGIN
        this.PATH_LOGOFF = config.PATH_LOGOFF
        this.PATH_TAGS = config.PATH_TAGS
        this.PATH_STATIONS = config.PATH_STATIONS
        this.PATH_STATIONS_UI_V1 = config.PATH_STATIONS_UI_V1
        this.PATH_STATIONS_UI_V2 = config.PATH_STATIONS_UI_V2
        this.PATH_STATIONS_DOMA_AI = config.PATH_STATIONS_DOMA_AI
        this.PATH_STATIONS_TREE = config.PATH_STATIONS_TREE
        this.PATH_STATIONS_FOR_TEST = config.PATH_STATIONS_FOR_TEST
        this.PATH_SERVICE = config.PATH_SERVICE
        this.PATH_FINANCE = config.PATH_FINANCE
        this.PATH_FAIL_ACQUIRING_REQUEST = config.PATH_FAIL_ACQUIRING_REQUEST
        this.PATH_TRANSACTIONS = config.PATH_TRANSACTIONS
        this.PATH_STATES = config.PATH_STATES
        this.PATH_ACTIVATE = config.PATH_ACTIVATE
        this.PATH_PROFILE = config.PATH_PROFILE
        this.PATH_DEVICES = config.PATH_DEVICES
        this.PATH_TARIFFS = config.PATH_TARIFFS
        this.PATH_DEALER_FEE = config.PATH_DEALER_FEE

        this.PATH_DELETE_ACCOUNT_INFO = config.PATH_DELETE_ACCOUNT_INFO

        this.DOMA_AI = config.DOMA_AI
        this.PATH_CONTACTS = config.PATH_CONTACTS
        this.PATH_OIDC_CALLBACK = config.PATH_OIDC_CALLBACK
        this.PATH_OIDC_LOGIN = config.PATH_OIDC_LOGIN
        this.PATH_GRANT_STORAGE_ACCESS = config.PATH_GRANT_STORAGE_ACCESS
        this.PATH_RT_OIDC_LOGIN = config.PATH_RT_OIDC_LOGIN
    }
}

const CurrentConfig = new Config()

export default CurrentConfig
